import React, { useState, useEffect } from 'react';
import axiosInstance from '../axiosConfig';
import { motion } from 'framer-motion';

function ViewDocuments() {
  const [documents, setDocuments] = useState([]);
  const [documentImages, setDocumentImages] = useState([]);
  const [currentDocumentId, setCurrentDocumentId] = useState(null);
  const [currentUser, setCurrentUser ] = useState(null);
  const [showUpdateImgModal, setShowUpdateImgModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [formDocumentData, setFormDocumentData] = useState({
    email: '',
    name: '',
    contact_number: '',
    employee_code: '',
    department: '',
  });
  const [formData, setFormData] = useState({
    id_proof: null,
    address_proof: null,
    pan_card: null,
    salary_slip: null,
    bank_statement: null,
    tax_return: null,
  });
  const [department, setDepartment] = useState('');
  const [ imageId, setImageId ] = useState ('');
  const [documentTypes, setDocumentTypes] = useState({});
  const [uploadTypes, setUploadTypes] = useState({});
  const [message, setMessage] = useState('');
  

  useEffect(() => {
    axiosInstance.get('/documents/')
      .then(response => {
        setDocuments(response.data);
      })
      .catch(error => {
        console.error(error);
      });

      axiosInstance.get('/upload-documents/')
  .then(response => {
    const uploadDocuments = response.data;
    const image = uploadDocuments.find((document) => document.document === currentDocumentId);
    if (image) {
      setImageId(image.id);
    } else {
      setImageId(null);
    }
  })
  .catch(error => {
    console.error(error);
  });

  axiosInstance.get('/document-types/')
    .then(response => {
      setDocumentTypes(response.data);
    })
    .catch(error => {
      console.error(error);
    });

    axiosInstance.get('/document-images/')
    .then(response => {
      setUploadTypes(response.data);
    })
    .catch(error => {
      console.error(error);
    });


    

    const userId = localStorage.getItem('id');
    if (userId) {
      axiosInstance.get(`/user/${userId}/`)
        .then(response => {
          setCurrentUser (response.data);
        })
        .catch(error => {
          console.error("Error fetching user details:", error);
        });
    }
  }, []);

  
  
  const openDetailsModal = (document) => {
    console.log("Opening details modal for document:", document);
    setSelectedDocument(document);
    setShowDetailsModal(true);

    axiosInstance.get(`/get-image/${document.id}/`)
      .then(response => {
        setDocumentImages(response.data);
      })
      .catch(error => {
        console.error("Error fetching document images:", error);
      });
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to Delete  this document?")) {
        axiosInstance.patch(`/status-change/${id}/disabled/`)
            .then(response => {
                setMessage('Document Deleted Successfully!');
                window.location.reload();
            })
            .catch(error => {
              if (error.response.data) {
                const errorMessages = Object.keys(error.response.data).map(key => {
                  return error.response.data[key].join(', ');
                }).join(', ');
                setMessage(errorMessages);
              } else {
                setMessage('An error occurred. Please try again.');
              }
            });
          }
        };
  


  return (
    <div className="dashboard-container">
      <div className="insurance-content">
      <div className="card main-card" style={{ backgroundColor: '#fff', color: '#000' }}>
              <motion.div
                  initial={{ y: -100, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.5 }}
                  className="department-header"
                >
                 <div className='doc'> 
                <h1> {department} Documents 
                <span>Create Documents for respective department.</span>
                </h1>
                </div>  
                </motion.div>
                
                <table className="striped-table">
  <thead>
    <tr>
      <th className='doc-table'>Employee Code</th>
      <th className='doc-name'>Name</th>
      <th>Department</th>
      <th>Branch</th>
    </tr>
  </thead>
  <tbody>
    {documents.map((document, index) => (
      <tr key={index}>
        <td>{document.employee_code}</td>
        <td>{document.name}</td>
        <td>{document.department}</td>
        <td>{document.branch}</td>
      </tr>
    ))}
  </tbody>
</table>


    </div>
    </div>
    </div>
  );
}

export default ViewDocuments;